import styled, { css } from 'styled-components';

import Card from '@components/Card';

const GroceriesContainer = styled(Card)`
  cursor: pointer;
  position: relative;
  justify-content: space-between;
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
  margin-left: 0;
  margin-right: 0;
  @media (max-width: 320px) {
    width: 21%;
  }
`;

export default GroceriesContainer;
